import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { HttpClient } from '@angular/common/http';
import { TransparencyService } from '../../utils/transparency.service';
import { Router } from '@angular/router';
import { Region } from '../../services/interfaces/region';
import { Territory } from '../../services/interfaces/territory';
import { LanguageService, SupportedLanguage } from '../../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',

  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] | undefined;
  territories: Territory[] = [];
  regions: Region[] = [];
  currentLanguage: SupportedLanguage = 'it';

  constructor(
    public transparencyService: TransparencyService,
    private http: HttpClient,
    private router: Router,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    this.loadRegAndTer();
    
    // Sottoscrivi ai cambiamenti di lingua
    this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
      this.initializeMenu(); // Ricarica il menu quando cambia la lingua
    });
  }

  loadRegAndTer(): void {
    this.http
    .get<Region[]>('assets/regions.json')
    .subscribe((regioni) => {
      this.regions = regioni;
      
      this.http
        .get<Territory[]>('assets/territories.json')
        .subscribe((territories) => {
          this.territories = territories;
          this.initializeMenu();
        });
    });
  }

  initializeMenu() {
    const langPrefix = this.languageService.getLanguagePrefix();
    
    this.items = [
      {
        label: 'Esplora',
        styleClass: 'esplora-item-menu',
        items: [
          {
            label: 'Territori vinicoli',
            items: [
              {
                label: "Seleziona il territorio vinicolo",
                styleClass: 'header-menu-item',
                disabled: true
              },
              ...this.getTerritoriVinicoli(),
            ]
          },
          {
            label: 'Regioni',
            items: [
              {
                label: "Seleziona la regione",
                styleClass: 'header-menu-item',
                disabled: true
              },
              ...this.getRegioni()
            ]
          }
        ]
      },
      {
        label: 'Esperienze',
        routerLink: `${langPrefix}/experiences`
      },
      {
        label: 'Su di noi',
        routerLink: `${langPrefix}/about-us`
      },
      {
        label: 'Blog',
        url: 'https://divinea.com/blog/',
      },
      {
        label: 'Divinea per Cantine',
        styleClass: 'buttonForWineries',
        url: 'https://business.divinea.com/'
      },
      {
        icon: 'pi pi-fw pi-user',
        styleClass: 'buttonForUser'
      },
      { separator: true },
      {
        label: this.getCurrentLanguageLabel(),
        styleClass: 'lang-item-menu',
        items: [
          {
            label: "Seleziona la lingua",
            styleClass: 'header-menu-item',
            disabled: true
          },
          {
            label: 'Italiano',
            icon: 'it',
            command: () => this.changeLanguage('it')
          },
          {
            label: 'Inglese',
            icon: 'en',
            command: () => this.changeLanguage('en')
          },
          {
            label: 'Tedesco',
            icon: 'de',
            command: () => this.changeLanguage('de')
          },
          {
            label: 'Francese',
            icon: 'fr',
            command: () => this.changeLanguage('fr')
          }
        ]
      }
    ];
  }

  getCurrentLanguageLabel(): string {
    const langMap: Record<SupportedLanguage, string> = {
      'it': 'IT',
      'en': 'EN',
      'de': 'DE',
      'fr': 'FR'
    };
    return langMap[this.currentLanguage];
  }

  changeLanguage(lang: SupportedLanguage): void {
    this.languageService.setLanguage(lang);
  }

  getTerritoriVinicoli(): any[] {
    return this.territories.map(territory => ({
      label: territory.name,
      command: () => this.linkToTerritories(territory.name)
    }));
  }

  getRegioni(): any[] {
    return this.regions.map(region => ({
      label: region.name,
      command: () => this.linkToRegion(region.name)
    }));
  }

  linkToTerritories(label: string): void {
    const langPrefix = this.languageService.getLanguagePrefix();
    const path = langPrefix ? `${langPrefix}/territories/${label}` : `/territories/${label}`;
    this.router.navigateByUrl(path);
  }

  linkToRegion(label: string): void {
    const langPrefix = this.languageService.getLanguagePrefix();
    const path = langPrefix ? `${langPrefix}/regions/${label}` : `/regions/${label}`;
    this.router.navigateByUrl(path);
  }
}
